/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from "react";

function AtmHistoryReport({ requests }: { requests: any[] }) {
  const nf = Intl.NumberFormat();

  const history: any[] = [];
  const denominations: any[] = [];

  const repGrandTotals: any[] = [];
  const cstGrandTotals: any[] = [];
  const rejGrandTotals: any[] = [];
  const dispGrandTotals: any[] = [];
  const remGrandTotals: any[] = [];
  const diffGrandTotals: any[] = [];

  let repAmountGrandTotal = 0;
  let remAmountGrandTotal = 0;
  let diffAmountGrandTotal = 0;

  requests.forEach((req) => {
    req.replenishments.forEach((rep: any) => {
      const denom = denominations.find(
        (dnm) => dnm.denomination === rep.denomination
      );

      if (!denom) {
        denominations.push({ denomination: rep.denomination });
      }
    });

    const replNotes: any = {};
    let totalReplAmount = 0;

    req.replenishments.forEach((rep: any) => {
      replNotes[rep.denomination] = rep.notes;
      totalReplAmount += rep.total;
    });

    repAmountGrandTotal += totalReplAmount;

    const cstNotes: any = {};
    let totalCstAmout = 0;

    if (req.cassettesNotes) {
      req.cassettesNotes.forEach((cn: any) => {
        cstNotes[cn.denomination] = cn.notes;
        totalCstAmout += cn.total;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        cstNotes[rep.denomination] = 0;
      });
    }

    const rjtNotes: any = {};
    let totalRjtAmount = 0;

    if (req.rejectedNotes) {
      req.rejectedNotes.forEach((rn: any) => {
        rjtNotes[rn.denomination] = rn.notes;
        totalRjtAmount += rn.total;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        rjtNotes[rep.denomination] = 0;
      });
    }

    const dispNotes: any = {};
    let totalDispAmount = 0;

    if (req.dispensed) {
      req.dispensed.forEach((dn: any) => {
        dispNotes[dn.denomination] = dn.notes;
        totalDispAmount += dn.total;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        dispNotes[rep.denomination] = 0;
      });
    }

    const rmnNotes: any = {};
    let totalRmnAmount = 0;

    if (req.remainingNotes) {
      req.remainingNotes.forEach((rn: any) => {
        rmnNotes[rn.denomination] = rn.notes;
        totalRmnAmount += rn.total;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        rmnNotes[rep.denomination] = 0;
      });
    }

    remAmountGrandTotal += totalRmnAmount;

    const diffNotes: any = {};
    let totalDiffAmount = 0;

    if (req.differenceNotes) {
      req.differenceNotes.forEach((rn: any) => {
        diffNotes[rn.denomination] = rn.notes;
        totalDiffAmount += rn.total;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        diffNotes[rep.denomination] = 0;
      });
    }

    diffAmountGrandTotal += totalDiffAmount;

    const serviceInfo = {
      serialNo: req.serialNo,
      replenishDate: req.replenishDate,
      residualDate: req.residualDate,
      replNotes,
      totalReplAmount,
      cstNotes,
      totalCstAmout,
      rjtNotes,
      totalRjtAmount,
      dispNotes,
      totalDispAmount,
      rmnNotes,
      totalRmnAmount,
      diffNotes,
      totalDiffAmount,
      remarks: req.remarks,
      //dispPercent,
      //remPercent,
    };

    history.push(serviceInfo);

    repGrandTotals.push(replNotes);
    cstGrandTotals.push(cstNotes);
    rejGrandTotals.push(rjtNotes);
    dispGrandTotals.push(dispNotes);
    remGrandTotals.push(rmnNotes);
    diffGrandTotals.push(diffNotes);
  });

  return (
    <div className="w-full">
      <table width="100%">
        <thead>
          <tr>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Sr. #
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Replenished Date
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Residuals Date
            </th>
            <th
              colSpan={denominations.length + 1}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Replenished Notes
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Received in Cassettes Notes
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Received in Bin Notes
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Dispensed Notes
            </th>
            <th
              colSpan={denominations.length + 1}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Remaining Notes
            </th>
            <th
              colSpan={denominations.length + 1}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Differences
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Remarks
            </th>
          </tr>
          <tr>
            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`repl${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}
            <th
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Total
            </th>
            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`cst${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`rej${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`disp${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`rem${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}
            <th
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Total
            </th>
            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`diff${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}
            <th
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Total
            </th>
          </tr>
        </thead>
        <tbody>
          {history.map((hry, i) => {
            return (
              <tr key={`row${i}`}>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                    width: "80px",
                  }}
                >
                  {hry.serialNo}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {hry.replenishDate}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {hry.residualDate}
                </td>
                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`rn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {hry.replNotes[denom]
                        ? nf.format(hry.replNotes[denom])
                        : 0}
                    </td>
                  );
                })}
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {hry.totalReplAmount ? nf.format(hry.totalReplAmount) : 0}
                </td>

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`cn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {hry.cstNotes[denom] ? nf.format(hry.cstNotes[denom]) : 0}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`rjn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {hry.rjtNotes[denom] ? nf.format(hry.rjtNotes[denom]) : 0}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`dispn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {hry.dispNotes[denom]
                        ? nf.format(hry.dispNotes[denom])
                        : 0}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`dn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {hry.rmnNotes[denom] ? nf.format(hry.rmnNotes[denom]) : 0}
                    </td>
                  );
                })}

                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {hry.totalRmnAmount ? nf.format(hry.totalRmnAmount) : 0}
                </td>

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`dn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {hry.diffNotes[denom]
                        ? nf.format(hry.diffNotes[denom])
                        : 0}
                    </td>
                  );
                })}
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {hry.totalDiffAmount ? nf.format(hry.totalDiffAmount) : 0}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {hry.remarks}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td
              colSpan={3}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Total
            </td>

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              repGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {repAmountGrandTotal ? nf.format(repAmountGrandTotal) : 0}
            </td>

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              cstGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              rejGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              dispGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              remGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(remAmountGrandTotal)}
            </td>

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              diffGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(diffAmountGrandTotal)}
            </td>

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default React.memo(AtmHistoryReport);
